<template>
  <div>
    <router-view />
  </div>
</template>

<style lang="scss" scoped></style>
